import { useContext } from 'react';
import useSWR from 'swr';
import { configurationContext } from '../contexts';
import { getUrl } from '../utils';
export function useMobileOfficeConfigurationQuery() {
  var _useContext = useContext(configurationContext),
    isDev = _useContext.isDev,
    mobileOfficeApiUrl = _useContext.mobileOfficeApiUrl,
    token = _useContext.token,
    tenant = _useContext.tenant,
    lang = _useContext.lang;
  return useSWR('/configuration', async function (url) {
    return getUrl(mobileOfficeApiUrl, url, {
      token: token,
      tenant: tenant,
      lang: lang,
      isDev: isDev
    });
  });
}
export function getFullNameFormat(configuration) {
  if (configuration !== null && configuration !== void 0 && configuration.CustomerConfiguration.FullNameFormat) {
    return configuration.CustomerConfiguration.FullNameFormat;
  }
  return '{LastName} {FirstName}';
}